<template>
    <div>
        <q-card class="kb-card" v-for="article in articleSearchResults" :key="article.id">
            <q-card-section class="row no-wrap kb-card-section" >
              <div class='kb-card-grid'>
                <div class="relative kb-img">
                  <q-img v-if='!article?.details?.img' class="q-mr-md kb-image" placeholder-src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAACWBAMAAADOL2zRAAAAG1BMVEXMzMyWlpaqqqq3t7fFxcW+vr6xsbGjo6OcnJyLKnDGAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABAElEQVRoge3SMW+DMBiE4YsxJqMJtHOTITPeOsLQnaodGImEUMZEkZhRUqn92f0MaTubtfeMh/QGHANEREREREREREREtIJJ0xbH299kp8l8FaGtLdTQ19HjofxZlJ0m1+eBKZcikd9PWtXC5DoDotRO04B9YOvFIXmXLy2jEbiqE6Df7DTleA5socLqvEFVxtJyrpZFWz/pHM2CVte0lS8g2eDe6prOyqPglhzROL+Xye4tmT4WvRcQ2/m81p+/rdguOi8Hc5L/8Qk4vhZzy08DduGt9eVQyP2qoTM1zi0/uf4hvBWf5c77e69Gf798y08L7j0RERERERERERH9P99ZpSVRivB/rgAAAABJRU5ErkJggg=="/>
                  <q-img v-if='article?.details?.img' class="q-mr-md kb-image" :src="'data:image/gif;base64,'+article?.details.img" />
                  <div :class='`bg-kb-${article.documenttype.toLowerCase()} text-white kb-badge`'>{{badgeName[article.documenttype.toLowerCase()]}}</div>
                </div>
                <div class="kb-title">{{ article.name }}</div>
                <div class="kb-postdate">Posted - {{ convertDate(article.details.posted) }}</div>
                <div class="kb-description">{{ article.shortdescription }}</div>
                <div class="kb-tags">
                  <q-chip v-for="tag in article.tags" square :color="`kb-tag-${article.documenttype.toLowerCase()}`" :text-color="`kb-tag-${article.documenttype.toLowerCase()}`" v-bind:key='tag'>{{ tag.toUpperCase() }}</q-chip>
                </div>
                </div>
            </q-card-section>
            <div class='kb-readmore'><q-btn outline class='readmore-btn' color='primary' :label="buttonLabel[article.documenttype.toLowerCase()]" :href="'/' + article.slug" /></div>
          </q-card>
          <div v-if="articleSearchResults.length==0">
            <div class="EmptyKBaseResult">No Knowledge Base Articles Found</div>
          </div>
    </div>
</template>

<script setup>
/* eslint-disable */
const props=defineProps({
  articleSearchResults: Array,
});
const badgeName = {
    resource: 'RESOURCES',
    blog: 'BLOGS',
    catalog: 'CATALOGS'
}

const buttonLabel = {
    resource: 'Read More',
    blog: 'Read More',
    catalog: 'View Catalog'
}

const convertDate = (date) => {
  if (date === null || date === '' || date.toLowerCase() === 'unknown') return ''
  const d = new Date(date)
  return d.toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric"
  })
}
</script>

<style lang="scss" scoped>
    .kb-table-title {
        font-weight: 700;
        font-size: 22px;
        line-height: 28px;
        padding-bottom: 20px;
        @media (max-width: $breakpoint-xs) {
          padding-bottom: 15px;
        }
    }
    .EmptyKBaseResult{
        text-align: center;
        padding: 15px;
        margin-top: 30px;
        font-size: 18px;
    }
    .kb-card {
        margin-bottom: 20px;
        width: 100%;
    }
    .kb-card-section {
      padding:30px 30px 10px 30px !important;
    }
    .kb-card-grid {
      display: grid;
    }
    .kb-img {
      grid-area: kbImg;
    }
    .kb-image {
      width:225px;
      height:195px;
    }
    .kb-title {
        grid-area: kbTitle;
        color: $apg-dark-grey;
        font-size: 22px;
        font-weight: 700;
        line-height: 28px;
        padding-bottom: 4px;
        width: 80%;
    }
    .kb-postdate {
        grid-area: kbPostdate;
        font-size: 14px;
        line-height: 12px;
        letter-spacing: 0.4px;
        color: $apg-med-grey;
        padding-bottom: 12px;
        margin-top: 10px;
    }
    .kb-description {
        grid-area: kbDesc;
        font-size: 14px;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: 0.25px;
        color: $apg-dark-grey;
        margin-bottom: 16px;
        margin-top: 16px;
        
        height: 54px;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        text-overflow: hidden;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }
    .kb-tags {
        grid-area: kbTags;
        margin-bottom: 16px;
        height: 32px;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        text-overflow: hidden;
        -webkit-box-orient: horizontal;
        overflow: hidden;
    }
    .kb-readmore {
      grid-area: kbReadmore;
      margin-left: 30%;
      padding-bottom: 15px;
    }
    .kb-badge {
        line-height: 16px;
        position: absolute;
        top:30px;
        right:30px;
        font-size:12px;
        padding:10px;
    }
    .bg-kb-resource {
        background-color: #00AA2D !important;
    }
    .bg-kb-blog {
        background-color: $primary !important;
    }
    .bg-kb-catalog {
        background-color: #C42424 !important;
    }
    .kb-card-grid {
      display: grid;
      grid-template-rows: auto auto auto auto auto;
      grid-template-columns: 230px auto;
      grid-column-gap: 24px;
      grid-row-gap: 0;
      grid-template-areas: "kbImg kbTitle   "
                            "kbImg kbPostdate"
                            "kbImg kbDesc    "
                            "kbImg kbTags    "
                            "kbImg kbReadmore";
    }

    @media only screen and (max-width: 767px) {
    // class that rounds over the top corners
      .kb-image {
        border-radius: 4px 4px 0px 0px;
        width: 100%;
        height: 180px;
        margin-bottom: 18px;
      }
      .kb-card-section {
        padding:0px !important;
        margin-bottom: 18px;
      }
      .kb-description {
          margin-bottom: 40px;
      }
      .kb-badge {
          top:21px;
          left:0px;
      }
      .readmore-btn {
        width: 100% !important;
      }
      .kb-card-grid {
        display: grid;
        grid-template-rows: auto auto auto auto auto;
        grid-template-columns: 17px auto 17px; /* 1 column */
        grid-column-gap: 0px;
        grid-row-gap: 0px;
        grid-template-areas: "kbImg kbImg      kbImg"
                             ".     kbTitle    ."
                             ".     kbPostdate ."
                             ".     kbDesc     ."
                             ".     kbTags     ."
                             ".     kbReadmore .";
      }
    }
</style>